import React from "react";
import swal from "sweetalert";
import "bootstrap";
import moment from "moment";
import WarningComponent from "../../helpers/modal";
import $ from "jquery";
import API from "../../helpers/endpointservice";
import axios from "axios";
import Select, { components } from "react-select";
import "react-datepicker/dist/react-datepicker.css";
import DateFnsUtils from "@date-io/date-fns";
import "date-fns";
import withRouter from "../../custom/withRouter";
import CommonIcon from "../../helpers/icons";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import { KeyboardDatePicker } from "@material-ui/pickers";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Toaster from "../../helpers/toaster";
import LoaderVisible from "../../helpers/loader";
import { id } from "date-fns/locale";

class Skillproficiency extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isMobile: false,
      isRadioMobile: false,
      isSmallMobile: false,
      iswebMobile: false,
      editScreen: false,
      courseCodeHeader: "",
      startDateEmpty: false,
      endDateEmpty: false,
      startDate: "",
      endDate: "",
      sidebar: true,
      isSkillMatrix: true,
      userId: 0,
      loader: false,
      ID: 0,
      isView: false,
      auditLog: []
    };
  }

  componentDidMount() {
    let user = localStorage.getItem("UserId");
    this.state.userId = user;
    const intervals = setInterval(() => {
      this.resize();
    }, 10);
    this.setState({
      loader: true
    });

    // let myOffcanvas = new window.bootstrap.Offcanvas(
    //   document.getElementById("AddScreen")
    // );
    // myOffcanvas.show();
    $("body").addClass("scrollhide");
    this.getSkillProficiency();

    // this.state.ID=
    // this.state.startDate=moment(this.state.startDate).format("DD-MMM-YYYY")
    // this.state.endDate=moment(this.state.endDate).format("DD-MMM-YYYY")
  }

  getSkillProficiency = () => {
    let apiUrl = `${API.GET_SKILL_PROFICIENCY}`;
    axios({
      method: "GET",
      url: apiUrl,
    }).then((res) => {
      if (res.status === 200) {
        this.state.auditLog = res.data.historyLogs
        this.state.isView = true;
        this.setState({
          ID: res?.data?.id,
          startDate: res?.data?.startdate,
          endDate: res?.data?.enddate,
          loader: false
        });
      } else {
        this.setState({
          loader: false
        });
      }
      let myOffcanvas = new window.bootstrap.Offcanvas(
        document.getElementById("AddScreen")
      );
      myOffcanvas.show();
    })
      .catch((error) => {
        this.setState({ loader: false });
        swal("Error!", "Something went wrong. Please try again.", "warning");
      });
  }

  resize = () => {
    if (window.innerWidth < 850) {
      this.state.isMobile = true;
    } else {
      this.state.isMobile = false;
    }
    if (window.innerWidth < 750) {
      this.state.isSmallMobile = true;
    } else {
      this.state.isSmallMobile = false;
    }
    if (window.innerWidth < 490) {
      this.state.isRadioMobile = true;
    } else {
      this.state.isRadioMobile = false;
    }
    if (window.innerWidth < 400) {
      this.state.iswebMobile = true;
    } else {
      this.state.iswebMobile = false;
    }

    this.state.height = window.innerHeight;
    this.setState({});
  };

  handleDateChange = (event, field) => {
    const inputDate = event;
    if (field === "startDate") {
      this.setState({
        startDate: inputDate
          ? moment(inputDate).format("DD-MMM-YYYY")
          : "",
        endDate: ""
      })
    }
    if (field === "endDate") {
      this.setState({
        endDate: inputDate
          ? moment(inputDate).format("DD-MMM-YYYY")
          : ""
      })
    }
    this.setState({}, () => { });
  };

  reset = () => {
    this.setState({
      startDate: "",
      endDate: "",
      startDateEmpty: false,
      endDateEmpty: false,
    });
    $('.startDate .MuiOutlinedInput-notchedOutline').css('border-color', '#edebe9');
    $('.endDate .MuiOutlinedInput-notchedOutline').css('border-color', '#edebe9');
  };

  closeAddScreen = () => {
    // $("#AddScreen").removeClass("show");
    this.setState({ sidebar: false });
    $("#propertiesScreen").removeClass("show");
    $("body").removeClass("scrollhide");
    this.reset();
    document.getElementById("closeSearchScreen").click();
  };

  validation = () => {
    let isvalid = true;
    // if (
    //   this.state.startDate === "" ||
    //   this.state.startDate === null ||
    //   this.state.startDate === undefined
    // ) {
    //   isvalid = false;
    //   this.setState({ startDateEmpty: true, isRequestLoader: false });
    // }
    // if (
    //   this.state.endDate === "" ||
    //   this.state.endDate === null ||
    //   this.state.endDate === undefined
    // ) {
    //   isvalid = false;
    //   this.setState({ endDateEmpty: true, isRequestLoader: false });
    // }
    // if(this.state.startDate === "" && this.state.endDate === ""){
    //   isvalid = true;
    // }
    // if ((this.state.startDate && this.state.endDate) || (this.state.startDate === "" && this.state.endDate === "")) {
    if (this.state.startDate !== "" && this.state.endDate !== "" && this.state.startDate !== null && this.state.endDate !== null) {
      isvalid = true;
      this.setState({
        startDateEmpty: false
      });
      this.setState({
        endDateEmpty: false
      })
      $('.startDate .MuiOutlinedInput-notchedOutline').css('border-color', '#edebe9');
      $('.endDate .MuiOutlinedInput-notchedOutline').css('border-color', '#edebe9');
    } else {
      isvalid = false;
      if (this.state.startDate == "" || this.state.startDate == null) {
        $('.startDate .MuiOutlinedInput-notchedOutline').css('border-color', '#ee192d');
        this.setState({
          startDateEmpty: true
        })
      } else {
        $('.startDate .MuiOutlinedInput-notchedOutline').css('border-color', '#edebe9');
        this.setState({
          startDateEmpty: false
        })
      }
      if (this.state.endDate == "" || this.state.endDate == null) {
        $('.endDate .MuiOutlinedInput-notchedOutline').css('border-color', '#ee192d');
        this.setState({
          endDateEmpty: true
        })
      } else {
        $('.endDate .MuiOutlinedInput-notchedOutline').css('border-color', '#edebe9');
        this.setState({
          endDateEmpty: false
        })
      }
      this.setState({ isRequestLoader: false });
    }
    return isvalid;
  };

  SubmitHandler = () => {
    let valid = this.validation();
    this.setState({ loader: true });
    if (valid) {
      let apiUrl = `${API.POST_SKILL_PROCIFIENCY}?userId=${this.state.userId * 1}`;
      axios({
        method: "POST",
        url: apiUrl,
        data: {
          id: this.state.ID,
          startdate: this.state.startDate ? moment(this.state.startDate).format("YYYY-MM-DD") : null,
          enddate: this.state.endDate ? moment(this.state.endDate).format("YYYY-MM-DD") : null
        }
      }).then((res) => {
        if (res.status === 200) {
          this.setState({ loader: false })
          toast.success("Duration Successfully Updated", {
            position: toast.POSITION.TOP_RIGHT,
            color: "#fff",
          })
          this.getSkillProficiency();
        } else {
          this.setState({ loader: false });
        }
      })
        .catch((error) => {
          this.setState({ loader: false });
          swal("Error!", "Something went wrong. Please try again.", "warning");
        });
    } else {
      this.setState({ loader: false });
    }
  };

  render() {
    let { menuToggle } = this.props;
    // const {
    //     isMobile,
    // }=this.state
    return (
      <>
        <Toaster />
        <LoaderVisible isLoader={this.state.loader} />
        <div
          className={`${this.state.isMobile
            ? "main-body-mobile table-responsive-xl"
            : menuToggle
              ? "menu-main-body table-responsive-xl"
              : "main-body table-responsive-xl"
            } `}
        >
          {/* <>
          {this.state.isMobile == true ? (
            <div className="mobile-head border-bottom w-100 ">
              <div className="col-12 mobile-title">
                {"Competency assessment duration"}
              </div>
            </div>
          ) : (
            <div className="head-fixed">
              <div className="title">
                <>
                  <CommonIcon fileName="Skillmatrixicon" />
                  <span className="pl-10 head-span">
                    {"Competency assessment duration"}
                  </span>
                </>
              </div>
            </div>
          )}
          </> */}
          <div
            className="offcanvas offcanvas-end offcanvasStyle skill-modal-align"
            tabIndex={-1}
            data-bs-scroll="false"
            data-bs-backdrop="false"
            id="AddScreen"
            aria-labelledby="offcanvasScrollingLabel"
          >
            {/* heading */}
            <div
              className={`offcanvas-header px-4 pt-4 ${this.state.isMobile ? "pb-2" : "pb-3 mt-10"
                }`}
            >
              <h6
                id="offcanvasRightLabel"
                className="modal-title pr-10 head-span fw-600"
              >
                {this.state.editScreen
                  ? this.state.courseCodeHeader
                  : "Competency assessment duration"}
              </h6>
              {/* <button
                className={`text-reset offcavasclose buttonstyle background-white ${
                  this.state.isMobile ? "pr-0" : "pr-0"
                }`}
                onClick={() => this.closeAddScreen()}
              >
                <CommonIcon
                  fileName="CrossIcon"
                  className="cursor-pointer app-image-hover"
                />
              </button> */}
              <button
                data-bs-dismiss="offcanvas"
                className="d-none"
                id="closeSearchScreen"
              ></button>
            </div>

            <div className="offcanvas-body px-4 pt-0">
              <div className="row">
                <div
                  className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${this.state.isMobile ? "" : "pb-2"
                    } `}
                >
                  <div className="form-group">
                    <label
                      className={`d-flex m-0 label-text ${this.state.isMobile ? "pt-2" : ""
                        }`}
                    >
                      <CommonIcon
                        className="properties-img-2"
                        fileName="DateIcon"
                      />{" "}
                      <span className="pl-5 properties-span">Start date</span>
                      {<span className="MuiFormHelperText-contained">*</span>}
                    </label>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <KeyboardDatePicker
                        autoOk
                        //minDate={this.state.startDate ? this.state.startDate : new Date()}
                        minDate={this.state.startDate && new Date(this.state.startDate) > new Date() ? new Date() : this.state.startDate}
                        variant="inline"
                        inputVariant="outlined"
                        className="form-control f-12 mt-2 startDate"
                        emptyLabel="dd-mmm-yyyy"
                        keyboardIcon={
                          <CommonIcon
                            className="properties-img-2"
                            fileName="calenderDate"
                          />
                        }
                        format="dd-MMM-yyyy"
                        value={
                          this.state.startDate ? this.state.startDate : null
                        }
                        size="small"
                        onChange={(e) => this.handleDateChange(e, "startDate")}
                        inputProps={{
                          readOnly: true,
                        }}
                      />
                    </MuiPickersUtilsProvider>

                    {this.state.startDateEmpty === true ? (
                      <span className="send-rework-label">
                        This field is required
                      </span>
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
                <div
                  className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${this.state.isMobile ? "" : "pb-2"
                    } `}
                >
                  <div className="form-group">
                    <label
                      className={`d-flex m-0 label-text ${this.state.isMobile ? "pt-2" : ""
                        }`}
                    >
                      <CommonIcon
                        className="properties-img-2"
                        fileName="DateIcon"
                      />{" "}
                      <span className="pl-5 properties-span">End date</span>
                      {<span className="MuiFormHelperText-contained">*</span>}
                    </label>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <KeyboardDatePicker
                        autoOk
                        minDate={this.state.startDate}
                        variant="inline"
                        inputVariant="outlined"
                        className="form-control f-12 mt-2 endDate"
                        emptyLabel="dd-mmm-yyyy"
                        keyboardIcon={
                          <CommonIcon
                            className="properties-img-2"
                            fileName="calenderDate"
                          />
                        }
                        format="dd-MMM-yyyy"
                        value={this.state.endDate ? this.state.endDate : null}
                        size="small"
                        onChange={(e) => this.handleDateChange(e, "endDate")}
                        inputProps={{
                          readOnly: true,
                        }}
                      />
                    </MuiPickersUtilsProvider>
                    {this.state.endDateEmpty === true ? (
                      <span className="send-rework-label">
                        This field is required
                      </span>
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
              </div>

              {/* <div className="row mt-1 float-end"> */}
              {/* <div
                className={`${this.state.iswebMobile ? "d-flex flex-column gap-2" : "d-flex gap-2"
                  } mb-3  ${this.state.isMobile ? "mt-4" : "mt-2"
                  } `}
              >
                <button className="btn border border-danger p-2 Clearbtn" onClick={this.reset} >
                  <CommonIcon className="button-img" fileName="ButtonRejectApprovalIcon" />
                  <span className="px-1 text-danger">Clear</span> </button>
                <button
                  className={`btn btn-light input-group offcavasclose filter-nextbtn p-2 border border-2 border-danger`}
                  onClick={this.SubmitHandler}
                >
                  <CommonIcon
                    fileName="ButtonSubmitIcon"
                    className="modal-img"
                  />
                  <span className="model-label pl-5">
                    {this.state.editScreen ? "Update" : "Submit"}
                  </span>
                </button>
              </div> */}
              {/* </div> */}
              <div className="d-flex col-12 col-sm-12 col-md-6 col-lg-6 mt-3 mb-1">
                <button className="btn rejectbutton d-flex clear-skill" onClick={this.reset} >
                  <CommonIcon className="button-img" fileName="ButtonRejectApprovalIcon" />
                  <span className="px-1">Clear</span> </button>
                <button
                  className={`btn approvebutton d-flex gap-1 mx-2`}
                  onClick={this.SubmitHandler}>
                  <span><CommonIcon fileName="ButtonSubmitIcon" /></span>
                  <span className="model-label pl-vendor3 pl-2">Submit</span>
                </button>
              </div>
              {
                <>
                  {this.state.isView && this.state.auditLog?.length > 0 && <div>
                    <div className="pt-3">
                      <h6 className="modal-title">Audit log</h6>
                    </div>
                    <div className="audit-table-wrapper audit-scroll-css">
                      <table className="px-3 audit-table w-100">
                        <thead>
                          <tr className="border-bottom">
                            <th className="p-rem">
                              Action
                            </th>
                            <th className="p-rem">
                              Action By
                            </th>
                            <th className="p-rem wid-45">
                              Description
                            </th>
                            <th className="p-rem">
                              Date
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {
                            this.state.auditLog?.map((x, i) => (
                              <tr className="border-bottom" key={i}>
                                <td className="p-rem" key={`${i}-action`}>{x.action ? x.action : "-"}</td>
                                <td className="p-rem" key={`${i}-actionby`}>{x.actionBy ? x.actionBy : "-"}</td>
                                <td className="p-rem" key={`${i}-desc`}>
                                  {x.description ? x.description : "-"}
                                </td>
                                <td className="p-rem" key={`${i}-created`}>
                                  {x.createdTime ? moment.utc(x.createdTime).local().format("DD-MMM-YYYY, hh:mm A") : "-"}
                                </td>
                              </tr>
                            ))
                          }
                        </tbody>
                      </table>
                    </div>
                  </div>}
                </>
              }
            </div>
          </div>
        </div>
      </>
    );
  }
}
export default withRouter(Skillproficiency);
